import { render } from "./SchemaConverterView.vue?vue&type=template&id=cf143c5c"
import script from "./SchemaConverterView.vue?vue&type=script&lang=js"
export * from "./SchemaConverterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__